<template>
  <div class="printOrderListBox">
    <div>
      <div class="storeImgPrompt">
        <div class="storeImgIcon el-icon-warning"></div>
        <div class="storeImgMess">
          <p>1.此处为您主页简介的背景图，最多上传1张幻灯片。</p>
          <p>
            2.
            支持jpg、jpeg、gif、png格式上传，建议WEB背景图片宽度1920px、高度300px、APP背景图片宽度375px、高度310px、大小2.00M以内的图片。
          </p>
        </div>
      </div>
      <div class="storeActiveImg">

        <!-- <el-button type="text" class="storeActivebut" @click="getImgsUp"
          >上传图片</el-button
        > -->

        <uploadImage
          :buttonName="'上传WEB背景图片'"
          @avatarChange="avatarChange($event)"
          @getDragImgFile="getDragImgFile($event)"
          @deleteImg="deleteImg($event)"
          :imgListShow = "false"
          class="storeActivebut"
          messSize='建议WEB背景图片长需要为1920px、宽需要为300px,大小2.00M以内'
        ></uploadImage>
        <img
              :src="imgListUrl"
              alt=""
          />

        <uploadImage
          :buttonName="'上传APP背景图片'"
          messSize='建议APP背景图片长需要为375px、宽需要为310px,大小2.00M以内'
          @avatarChange="avatarChange1($event)"
          @getDragImgFile="getDragImgFile1($event)"
          @deleteImg="deleteImg1($event)"
          :imgListShow = "false"
          class="storeActivebut"
        ></uploadImage>
        <img
              :src="appImgListUrl"
              alt=""
          />
      </div>
    </div>
  </div>
</template>

<script>
import uploadImage from "../../components/uploadImage/index";
import {getDesignBanner, saveDesignBanner} from "../../utils/interface";
export default {
  data() {
    return {
      createDate: "",
      demandName: "",
      designerName: "",
      demandPerson: "",
      transactionStatus: "",
      evaluateStatus: "",
      loading: true,
      form: {
          // imgList: [],
          appBannerPath:null,
          bannerPath:null,
          fileName:null,
          bannerType:'DESIGNER',
      },
      imgListUrl: "",
        appImgListUrl: "",
      pageNo: 1,
      total: 100,
      pageSize: 5,
    };
  },
  components: {
    uploadImage,
  },
    created() {
        this.getDesignBanner();
    },
  methods: {
    // 图片上传
    // 上传成功
    avatarChange(val) {
        if(val.length > 0){
            this.form.bannerPath = val[val.length - 1].url;
            this.form.fileName = val[val.length - 1].name;
            saveDesignBanner(this.form).then((response) => {
                if(response){
                    this.imgListUrl = val[val.length - 1].url;
                    this.$message({
                        type: "success",
                        message: response.message,
                    });
                }
            });

        }
    },
    // 获取拖拽后的图片
    getDragImgFile(file) {
      if (file) {
        this.form.imgList = file;
      }
    },
    // 删除图片
    deleteImg(val) {
      this.form.imgList = val;
    },
    // 上传成功
    avatarChange1(val) {
        if(val.length > 0){
            this.form.appBannerPath = val[val.length - 1].url;
            saveDesignBanner(this.form).then((response) => {
                if(response){
                    this.appImgListUrl = val[val.length - 1].url;
                    this.$message({
                        type: "success",
                        message: response.message,
                    });
                }
            });

        }
    },
    // 获取拖拽后的图片
    getDragImgFile1(file) {
      if (file) {
        this.form.imgList1 = file;
      }
    },
    // 删除图片
    deleteImg1(val) {
      this.form.imgList1 = val;
    },
      getDesignBanner() {
          getDesignBanner().then((response) => {
              if(response){
                  if(response.list != null && response.list.length > 0){
                      this.imgListUrl = response.list[0].bannerPath;
                      this.appImgListUrl = response.list[0].appBannerPath;
                  }
              }
          });
      },
  },
};
</script>

<style scoped lang="less">
.printOrderListBox {
  padding: 20px 20px 20px;
  /deep/ .el-tabs__item {
    padding: 0 25px !important;
    text-align: center;

    &:hover {
      color: #3686d7;
    }

    &:after {
      content: "";
      position: absolute;
      right: 0;
      bottom: 12px;
      width: 1px;
      height: 15px;
      background-color: #e4e7ed;
      z-index: 1;
    }

    &:last-child:after {
      content: "";
      width: 0;
      height: 0;
    }
  }

  /deep/ .el-tabs__active-bar {
    height: 3px;
    background-color: #3686d7;
  }

  /deep/ .el-tabs__item.is-active {
    color: #3686d7;
  }

  /deep/ .el-tabs__nav-wrap::after {
    height: 1px;
  }
  .storeImgPrompt {
    display: flex;
    border: 1px solid #0c76d356;
    border-radius: 10px;
    padding: 0px 16px;
    background: #f4f9ff;
    font-size: 14px;
    margin-bottom: 20px;
    .storeImgIcon {
      margin-top: 14px;
      font-size: 20px;
      margin-right: 10px;
      color: #0c75d3;
    }
  }
  .storeActiveImg {
    margin-bottom: 22px;
    // display: flex;

    img {
      border-radius: 10px;
      width: 100%;
      margin-bottom: 16px;
    }
    .storeActivebut {
      width: 160px;
      background: #3d7fff;
      border: none;
      font-size: 14px;
      color: #ffffff;
      margin-right: 10px;
      border-radius: 5px;
      margin-bottom: 16px;
      /deep/button{
        width: 160px !important;
      }
    }
  }
  .orderListTable {
    min-width: 1400px;
    .tableHeader {
      display: flex;
      width: 100%;
      height: 35px;
      line-height: 35px;
      background: #f3f7ff;
      border-radius: 5px;
      // margin: 0 0 15px;
      border-radius: 10px 10px 0 0;
      li {
        text-align: center;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.85);
      }
    }

    .tableBody {
      li {
        width: 100%;
        border-top: 1px solid #f2f2f2;
        border-bottom: 1px solid #f2f2f2;
        // border-radius: 0 0 10px 10px;
        // margin-bottom: 15px;

        .itemBottom {
          display: flex;
          align-items: center;
          color: #333;
          font-size: 13px;

          .orderInfo {
            padding: 20px;
            .orderInfoName {
              font-size: 14px;
              color: #000000;
              padding-bottom: 10px;
            }
            .infoContent {
              font-size: 13px;
              color: #999999;
              line-height: 22px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 3;
              -webkit-box-orient: vertical;
            }
          }

          .arguments {
            text-align: center;
          }
          .payment {
            h3 {
              font-size: 14px;
              font-weight: 700;
              margin: 0;
            }

            .title {
              font-size: 12px;
              color: #999999;
            }
          }
          .status {
            font-size: 14px;
          }
          .operation {
            padding: 20px 0 10px;
          }

          .operationBtn {
            display: block;
            color: #0c75d3;
            text-align: center;
            width: 100%;
            margin: 0;
          }
        }
      }
    }

    .name {
      width: 270px;
      img {
        width: 80%;
        margin-left: 10px;
        border-radius: 10px;
      }
      // flex: 1;
    }

    .price {
      flex: 1;

      text-align: center;
    }

    .num {
      width: 200px;
      text-align: center;
    }

    .arguments {
      width: 170px;
    }

    .payment {
      width: 180px;
      text-align: center;
    }

    .status {
      width: 200px;
      text-align: center;
    }

    .operation {
      width: 180px;
      text-align: center;
      .operationUploadBtn {
        width: 102px !important;
        height: 34px;
        padding: 0;
        line-height: 34px;
        text-align: center;
        font-weight: 700;
        color: rgba(0, 102, 204, 0.8);
        font-size: 14px;
        border-color: rgba(0, 102, 204, 0.8);
        display: block;
        margin: 0 auto 10px !important;
      }
    }
  }
  .pagination {
    margin-top: 20px;
    text-align: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/store/storeDecorate.vue